<template>
    <div
            class="modal fade"
            id="sys_ammeterEdit_modal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myModalLabel"
            aria-hidden="true"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    <h4 class="modal-title" id="myModalLabel">编辑电表</h4>
                </div>
                <!-- modal-body-->
                <div class="modal-body">
                    <div class="form-horizontal">
                        <div class="form-group">
                            <label class="col-sm-2 control-label">电表编号：</label>
                            <div class="col-sm-4">
                                <input type="hidden" name="id" v-model="ammeterInfo.id"/>
                                <input
                                        type="text"
                                        class="form-control"
                                        name="stam_ammeternumbering"
                                        v-model="ammeterInfo.ammeter_numbering"
                                />
                            </div>
                            <label class="col-sm-2 control-label">电表位置：</label>
                            <div class="col-sm-4">
                                <input
                                        class="form-control"
                                        name="stam_ammeterposition"
                                        v-model="ammeterInfo.position"
                                />
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-2 control-label">电表分类：</label>
                            <div class="col-sm-4">
                                <select
                                        name
                                        class="chosen-select stam_category"
                                        v-model="ammeterInfo.stam_category"
                                >
                                    <option value="A">A 在用分表</option>
                                    <option value="B">B 在用总表</option>
                                    <option value="C">C 智能分表</option>
                                    <option value="D">D 智能总表</option>
                                    <option value="Z">Z 临时表</option>
                                    <option value="X">X 未知分类</option>
                                </select>
                            </div>

                            <label class="col-sm-2 control-label ammeterModel" style="display:none;">电表型号</label>
                            <div class="col-sm-4 ammeterModel" style="display:none;">
                                <select
                                        name
                                        class="chosen-select_modal"
                                        placeholder="请选择电表型号"
                                        v-model="ammeterInfo.model"
                                >
                                    <option v-for="(item,index) in modelList" :key="index" :value="item">{{item}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-2 control-label">电表备注：</label>
                            <div class="col-sm-4">
                                <input
                                        type="text"
                                        class="form-control"
                                        name="stam_ammeterinfo"
                                        v-model="ammeterInfo.remark"
                                />
                            </div>
                        </div>

                        <!--上传图片-->
                        <div class="form-group">
                            <label class="col-sm-2 control-label">电表照片：</label>
                            <div class="col-sm-4" v-if="ammeterInfo.picture">
                                <img
                                        :src="ammeterInfo.picturePath"
                                        style="width:100%;height:300px;object-fit:cover;"
                                        @click="enlarge(ammeterInfo.picturePath)"
                                />
                            </div>
                            <div v-else></div>
                            <div class="col-sm-4">
                                <input
                                        type="file"
                                        class="form-control file-pretty_ammeter"
                                        id="changeAmmeterPic"
                                        @change="changeAmmeterPic('changeAmmeterPic')"
                                />
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-2 control-label">经纬度：</label>
                            <div class="col-sm-4">
                                <input name="lnglat" class="form-control" v-model="ammeterInfo.center" readonly/>
                            </div>
                            <button
                                    type="button"
                                    class="btn btn-info col-sm-2 reChoose"
                                    @click="reChoose"
                            >在地图上选择位置
                            </button>
                            <button
                                    type="button"
                                    class="btn btn-info col-sm-2 determine"
                                    @click="determine"
                                    style="display: none;"
                            >确定
                            </button>
                        </div>
                        <div id="container" style="width:100%;height:0;"></div>
                    </div>
                </div>
                <!-- modal-footer -->
                <div class="modal-footer">
                    <button type="button" @click="closeModal" class="btn btn-default">关闭</button>
                    <button type="button" class="btn btn-primary" @click="submitAmmeter">提交</button>
                </div>
            </div>
        </div>
        <img class="imgLayer" v-show="imgShow" :src="imgSrc" alt @click="narrow"/>
    </div>
</template>
<script>
  import AMap from 'AMap'

  var map
  var marker

  export default {
    data () {
      return {
        ammeterInfo: {
          // ammeter_numbering: null,
          // center: "116.418487,40.006702",
          // create_datetime: "2017-12-07 14:46:55",
          // id: "guid431DC74D-3AA6-4ECE-9871-17F43FEEB0F5",
          // info: null,
          // model: null,
          // picture: null,
          // position: null,
          // remark: null,
          // stam_category: "A",
          // station_id: "guid5586CB21-7080-4022-9ECE-7F8CFD68578F"
        },
        modelList: ['DDZY251-NB'], // 电表型号
        imgSrc: '', // 被放大图片的路径
        imgShow: false,
      }
    },
    props: ['msgAmmeterid'],
    mounted: function () {
      map = new AMap.Map('container', {
        resizeEnable: true,
        center: [116.397477, 39.908692],
        zoom: 13
      })
      marker = new AMap.Marker({
        position: map.getCenter(),
        offset: new AMap.Pixel(-13, -30),
        draggable: true
      })
      marker.setMap(map)
      $('.file-pretty_ammeter').prettyFile()
    },
    methods: {
      // 关闭模态窗
      closeModal: function () {
        $('#sys_ammeterEdit_modal').modal('hide')
      },
      // 三个checkbox的状态设置
      checboxfn: function (type) {
        console.log(this.type)
      },
      // 图片放大
      enlarge: function (src) {
        console.log(src)
        var self = this
        self.imgShow = true
        self.imgSrc = src
      },
      // 图片缩小
      narrow: function () {
        var self = this
        self.imgShow = false
      },
      // 通用文件上传--返回路径
      changeAmmeterPic: function () {
        // 上传返回file_path;
        var self = this
        self.global.uploadfile(
          self,
          'changeAmmeterPic',
          function (res) {
            console.log(res)
            if (res.status == 'success') {
              console.log(res.file_path)
              self.ammeterInfo.picture = res.file_path
              self.ammeterInfo.picturePath = self.global.ossHost + res.file_path
              console.log(self.picturePath)
            } else {
              alert('图片上传失败')
            }
          },
          function () {
            alert('图片上传失败')
          }
        )
      },
      //渲染数据 获取电表详情
      getData: function () {
        var self = this
        $('.input-large').val('')
        console.log('edit', self.msgAmmeterid)
        $('.stam_category')
          .chosen({
            disable_search_threshold: 10,
            disable_search: true,
            width: '100%'
          })
          .change(function () {
            self.ammeterInfo.stam_category = $('.stam_category').val()

            if (
              $('.stam_category').val() == 'C' ||
              $('.stam_category').val() == 'D'
            ) {
              $('.ammeterModel').show()
              self.ammeterInfo.model = 'DDZY251-NB'
            } else {
              $('.ammeterModel').hide()
              self.ammeterInfo.model = ''
            }
            console.log('---', self.ammeterInfo)
          })
        $('.chosen-select_modal')
          .chosen({
            disable_search_threshold: 10,
            disable_search: true,
            width: '100%'
          })
          .change(function () {
            self.ammeterInfo.model = $('.chosen-select_modal').val()
          })
        self.global.axiosGet(
          self,
          'ammeter/' + self.msgAmmeterid + '/',
          function (res) {
            res.picturePath = self.global.ossHost + res.picture
            self.ammeterInfo = res
            // console.log("渲染数据", res);
            if (res.stam_category == 'C' || res.stam_category == 'D') {
              $('.ammeterModel').show()
              $('.chosen-select_modal')
                .val(self.modelList[0])
                .trigger('chosen:updated')
            } else {
              $('.ammeterModel').hide()
            }
            map.setCenter(res.center.split(','))
            marker.setPosition(res.center.split(','))
            setTimeout(function () {
              $('.stam_category').trigger('chosen:updated')
            }, 500)
          },
          function () {
            alert('操作失败,请稍后重试!')
          }
        )
      },
      //提交电表信息
      submitAmmeter: function () {
        console.log('提交修改电表')
        var self = this
        var putData = {}
        putData.numbering = self.ammeterInfo.ammeter_numbering
        putData.longitude = marker.getPosition().getLng()
        putData.latitude = marker.getPosition().getLat()
        putData.position = self.ammeterInfo.position
        putData.category = self.ammeterInfo.stam_category
        putData.model = self.ammeterInfo.model
        putData.remark = self.ammeterInfo.remark
        putData.picture = self.ammeterInfo.picture
        console.log(putData)
        self.global.axiosPut(
          self,
          'ammeter/' + self.ammeterInfo.id + '/',
          putData,
          function (res) {
            console.log('提交电表信息---', res)
            if (res.message == 'submitted') {
              alert('已提交变更申请')
            } else if (res.status == 'success') {
              alert('变更完成')
            } else {
              alert('提交失败')
            }
            self.closeModal()
          },
          function (res) {
            self.closeModal()
            alert('提交失败,请稍后再试或联系管理员')
          }
        )
      },
      // 在地图上选择经纬度
      reChoose: function () {
        $('.reChoose')
          .hide()
          .siblings('.determine')
          .show()
        $('#container').animate({
          height: '500px'
        })
      },
      //选择位置结束
      determine: function () {
        var self = this
        $('.determine')
          .hide()
          .siblings('.reChoose')
          .show()
        $('#container').animate({
          height: '0px'
        })
        self.ammeterInfo.center =
          marker.getPosition().getLng() + ',' + marker.getPosition().getLat()
      }
    }
  }
</script>
<style scoped>
    .a-upload {
        padding: 6px 53px;
        line-height: 20px;
        position: relative;
        cursor: pointer;
        color: #fff;
        background: #23c6c8;
        border-radius: 4px;
        overflow: hidden;
        display: inline-block;
    }

    .a-upload input {
        position: absolute;
        font-size: 100px;
        right: 0;
        top: 0;
        opacity: 0;
        filter: alpha(opacity=0);
        cursor: pointer;
    }

    .a-upload:hover {
        color: #444;
        background: #eee;
        border-color: #ccc;
        text-decoration: none;
    }

    .enlarge_layer {
        position: fixed;
        top: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.2);
        z-index: 999;
        overflow: scroll;
    }

    .enlarge_layer img {
        height: 100%;
        display: block;
        margin: 0 auto;
    }

    .imgLayer {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        z-index: 999;
        max-width: 100%;
        max-height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/views/ammeter/ammeterEdit.vue